import React, { createContext, useContext } from "react";
import { IHprService } from "../services/HprService";

const context = createContext<IHprService | null>(null);
const { Provider } = context;

export const useHprService = () => {
    const service = useContext(context);
    if (!service) throw new Error("Failed to get HPR servvice");
    return service;
};

// Provider
export const HprServiceProvider: React.FC<{ service: IHprService }> = ({ children, service }) => {
    return (
        <Provider value={service}>
            {children}
        </Provider>
    );
};
